import script from "./JaTemplateSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./JaTemplateSelect.vue?vue&type=script&setup=true&lang=js"

import "./JaTemplateSelect.vue?vue&type=style&index=0&id=4ac84b98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ac84b98"]])

export default __exports__